var ENDPOINTS = Object.freeze({
    /** Authentication */
    AUTH_AUTO: '/anon/sandbox',
    AUTH_LOGIN: '/anon/login',
    AUTH_LOGIN_FB: '/anon/login/facebook',
    AUTH_LOGIN_GOOGLE: '/anon/login/google',
    AUTH_LOGIN_AUTO: '/anon/login/{type}',
    AUTH_REGISTER: '/anon/register',
    AUTH_REGISTER_VERIFICATION: '/anon/validate',
    AUTH_REGISTER_FB: '/anon/register/facebook',
    AUTH_REGISTER_GOOGLE: '/anon/register/google',
    AUTH_PASSWORD_FORGOTTEN: '/anon/forgotten-password',
    AUTH_PASSWORD_FORGOTTEN_VALIDATION: '/anon/password-recovery-validation',
    AUTH_PASSWORD_RESET: '/anon/reset-password',
    /** Busuu Live backend */
    BUSUU_LIVE_GQL: '/',
    /** B2B */
    B2B_INSTITUTION_FIND_INVITE: '/anon/invites/find?institution_name={institutionName}&institution_code={institutionCode}',
    B2B_SSO_INSTITUTION_USER_REGISTER: '/institution-user',
    /** Certificate */
    CERTIFICATE: '/certificate/{courseLanguage}/{objectiveId}',
    CERTIFICATE_SEND: '/certificates/{userId}/notification',
    /** Course */
    COURSE_PROGRESS: '/api/v2/progress/{language}',
    COURSE_PROGRESS_STATS: '/progress/users/{userId}/stats',
    COURSE_PROGRESS_LEVEL: '/progress/completed_level?language={language}',
    COURSE_CONFIG: '/api/anon/course-config',
    COURSE_COMPONENT: '/api/v2/component/{compId}',
    COURSE_TRACK_PROGRESS: '/progress',
    COURSE_STRUCTURE: '/api/course-pack/{courseId}',
    COURSES_OVERVIEW: '/api/courses-overview',
    COURSES_LESSON_SCORE: '/api/scores/objectives/{objectiveId}',
    COURSES_STREAK: '/api/users/progress/streak',
    COURSE_CHECKPOINT_PROGRESS: '/checkpoints/progress',
    COURSE_CHECKPOINT_SCORE: '/checkpoints/{objectiveId}/progress?lang={courseLang}',
    COURSES_DAILY_CHALLENGES: '/api/daily-challenges',
    COURSES_ESTIMATE_GOAL: '/estimate-goal',
    COMPLETED_LESSONS: '/progress/users/{userId}/completed-lessons',
    COURSE_DAILY_GOAL: '/api/daily-goal',
    /** Friends */
    FRIEND_RECOMMENDATIONS: '/users/friends/recommendations',
    FRIEND_REQUEST_PENDING: '/friends/pending',
    FRIEND_REQUEST_SEND: '/friends/send/{userId}',
    FRIEND_REQUEST_VALIDATE: '/friends/validate',
    FRIEND_REQUEST_BATCH: '/friendrequests/send',
    FRIEND_DELETE: '/friends/{userId}',
    /** Friends achievements */
    FRIENDS_ACHIEVEMENTS: '/achievements',
    FRIENDS_ACHIEVEMENTS_POST_REACTION: '/achievements/{id}/reactions',
    /** Grammar Review */
    GRAMMAR_REVIEW_GET_COMP: '/api/grammar/activity',
    GRAMMAR_REVIEW_GET_PROGRESS: '/api/grammar/progress',
    GRAMMAR_REVIEW_GET_LINKED_ACTIVITIES: '/api/grammar/topic/{grammarTopicId}',
    /** Language exam */
    LANGUAGE_EXAM_START: '/api/exam/{examId}/start',
    LANGUAGE_EXAM_PROGRESS: '/api/exam/{examId}/progress',
    /** Notifications */
    NOTIFICATIONS: '/notifications?include_voice=1',
    NOTIFICATIONS_VIEW_ALL: '/notifications/{status}',
    /** Placement Test */
    PLACEMENT_TEST_START: '/placement/start',
    PLACEMENT_TEST_PROGRESS: '/placement/progress',
    PLACEMENT_TEST_SKIP: '/placement/skip',
    /** Pricing */
    PRICING_DISCOUNT: '/coupon/{coupon}',
    PRICING: '/payments/prices/?country_code={countryCode}&user_group_id={userGroup}&platform={platform}',
    PRICING_AUTH: '/payments/prices/me?country_code={countryCode}&user_group_id={userGroup}&interface_language={interfaceLanguage}&platform={platform}',
    /** Promotions */
    PROMOTION: '/promotion?platform={platform}&interface_language={interfaceLanguage}&country_code={countryCode}',
    /** Referrals */
    REFERRAL_CODE: '/anon/referral-tokens/{referralCode}',
    REFERRAL_EXERCISE_CODE: '/anon/exercise-tokens/{exerciseCode}',
    REFERRAL_BY_USER_ID: '/users/{userId}/referrals',
    REFERRAL_URL_BY_USER_ID: '/users/{userId}/referral_url',
    /** Social */
    SOCIAL_CONVERSATION: '/users/{userId}/exercises',
    SOCIAL_CORRECTION_EXERCISE: '/exercises/{exerciseId}',
    SOCIAL_CORRECTION_EXERCISE_COMMENT: '/exercises/{exerciseId}/corrections',
    SOCIAL_CORRECTION_EXERCISE_RATE: '/exercises/{exerciseId}/rate',
    SOCIAL_CORRECTION_POOL: '/exercises/pool',
    SOCIAL_BEST_CORRECTION: '/exercises/{exerciseId}/best-correction',
    SOCIAL_LEAGUE_COMPETITORS: '/league/{leagueId}/users',
    SOCIAL_INTERACTIONS_COMMENT: '/interactions/{commentId}/comments',
    SOCIAL_INTERACTIONS_VOTE: '/interactions/{commentId}/vote',
    SOCIAL_CORRECTIONS_BY_USER_ID: '/users/{userId}/corrections?languages={languages}&limit={limit}&offset={offset}&type=writing,picture,video,voice',
    SOCIAL_EXERCISE_BY_USER_ID: '/users/{userId}/exercises?languages={languages}&limit={limit}&offset={offset}&type=writing,picture,video,voice',
    /** Study Plan */
    STUDY_PLAN: '/study_plan/stats?language={language}',
    STUDY_PLAN_WITH_STATUS: '/study_plan/stats?language={language}&status={status}',
    STUDY_PLAN_DELETE: '/study_plan/{id}',
    STUDY_PLAN_ESTIMATE: '/study_plan/estimate',
    STUDY_PLAN_ACTIVATE: '/study_plan/{id}/activate',
    /** Subscribe */
    SUBSCRIBE_STRIPE: '/payments/subscriptions/stripe',
    SUBSCRIBE_STRIPE_CONFIRM: '/payments/subscriptions/{subscriptionId}/confirm',
    SUBSCRIBE_BRAINTREE_GET_TOKEN: '/payments/braintree/token',
    SUBSCRIBE_BRAINTREE: '/payments/subscriptions/braintree',
    SUBSCRIPTION_GET: '/users/{userId}/subscription',
    SUBSCRIPTION_GET_ADMIN: '/payments/subscriptions/user/admin/{userUuid}',
    SUBSCRIPTION_CANCEL: '/payments/subscriptions/{subscriptionId}',
    SUBSCRIPTION_TRACKING: '/payments/subscriptions/{subscriptionId}/tracking',
    SUBSCRIPTION_FT_ELIGIBILITY: '/payments/customers/{userUuid}/free-trial-eligibility',
    SUBSCRIPTION_FT_ELIGIBILITY_ADMIN: '/payments/customers/admin/{userUuid}/free-trial-eligibility',
    /** Users */
    USER_ME: '/users/me',
    USER_CONFIG: '/anon/config?platform=web',
    USER_BY_ID: '/users/{userId}',
    USER_AVATAR_UPLOAD: '/users/{userId}/avatar/upload',
    USER_AVATAR_CROP: '/users/{userId}/avatar/crop',
    USER_DELETE: '/users/{userId}',
    USER_EVENTS: '/users/events',
    USER_FRIENDS: '/users/{userId}/friends',
    /** Vocabulary */
    VOCABULARY: '/vocabulary/{option}/{courseLang}?translations={translations}',
    VOCABULARY_DELETE: '/vocabulary/{vocabularyId}',
    VOCABULARY_EXERCISE: '/vocabulary/exercise',
    VOCABULARY_SMART_REMEDIATION: '/smart_remediation',
    /** Voucher */
    VOUCHER_REDEMPTION: '/vouchers/redemption',
    /** Misc */
    ACCEPT_TERMS: '/anon/accept-terms-conditions',
    BRANCHES: '/api/slate/branches',
    CONTACT: '/users/{userId}/feedback',
    FLAGS: '/flags',
    MARK_ENTITY: '/api/v2/mark_entity',
    UNSUBSCRIBE_CRM: '/anon/users/unsubscribe?email={email}&user_id={userId}',
    POINTS_CONFIGURATION: '/api/points-configuration',
    LEARNING_MOTIVATION: '/learning-motivation',
});

/**
 * Gets and builds an endpoint
 * @param {object} obj - An object
 * @param {string} obj.baseUrl - base url from the client (eg: https://api.busuu.com)
 * @param {string} obj.endpoint - endpoint
 * @param {object} obj.replacements - replace any {FOO} types in the endpoint string (eg: { '{countryCode}': 'ES' })
 * @param {string} obj.extraQuery - any extra queries (eg: &coupon_code=foobar&user_group=standard)
 * @returns {string} full endpoint
 */
var getEndpoint = function (_a) {
    var baseUrl = _a.baseUrl, endpoint = _a.endpoint, _b = _a.replacements, replacements = _b === void 0 ? {} : _b, _c = _a.extraQuery, extraQuery = _c === void 0 ? '' : _c;
    if (!baseUrl)
        throw new Error('getEndpoint() - baseUrl param missing.');
    if (!endpoint)
        throw new Error('getEndpoint() - endpoint param missing.');
    // Ensure that the endpoint string passed exists
    var exists = Object.values(ENDPOINTS).some(function (value) { return endpoint === value; });
    if (!exists)
        throw new Error('getEndpoint() - Endpoint does not exist.');
    // Handle any replacements of params
    Object.entries(replacements).forEach(function (_a) {
        var param = _a[0], replacement = _a[1];
        endpoint = endpoint === null || endpoint === void 0 ? void 0 : endpoint.replace(param, replacement);
    });
    // Return the fully constructed endpoint
    return "" + baseUrl + (extraQuery ? endpoint + extraQuery : endpoint);
};

export { ENDPOINTS, getEndpoint };
//# sourceMappingURL=index.esm.js.map
